import { Component } from '@angular/core';

@Component({
  selector: 'app-collects',
  templateUrl: './collects.component.html',
  styleUrls: ['./collects.component.css']
})
export class CollectsComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
